import { render, staticRenderFns } from "./AddressChangeStep.vue?vue&type=template&id=930dc822"
import script from "./AddressChangeStep.vue?vue&type=script&lang=ts"
export * from "./AddressChangeStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports